import React from 'react';
import {Icon} from 'semantic-ui-react';

export const renderCheckIcon = () => {
  return <Icon name='check circle' color='green' size='large' />;
};

export const renderCrossIcon = () => {
  return <Icon name='cancel' color='red' size='large' />;
};

export const getColumns = ({
  handleChangeCheck,
  maxVehiclesSelected,
  isVehSelected,
}) => {
  return [
    /* {
      'id': 'processCheckBox',
      'width': 40,
      'Cell': ({row}) => {
        const isSelected = isVehSelected(row.original);
        return (<div style={{'textAlign': 'center'}}>
          <Checkbox
            checked={isSelected}
            disabled={maxVehiclesSelected() && !isSelected}
            onChange={(e) => handleChangeCheck(e, row.original, isSelected ? 'DELETE' : 'INSERT')}
          /></div>
        );
      },
      'Filter': () => {
        return null;
      },
    }, */
    {
      'Header': 'CHASIS',
      'accessor': 'chassis',
    },
    {
      'Header': 'RESERVADO PARA',
      'accessor': 'reserved_for',
    },
    {
      'Header': 'SFX',
      'accessor': 'sfx',
      'width': 65,
      'align': 'center',
    },
    {
      'Header': 'MODELO',
      'accessor': 'model',
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'description',
    },
    {
      'Header': 'PEDIDO',
      'accessor': 'carOrder',
    },
    {
      'Header': 'FECHA LIQUIDACION',
      'accessor': 'liquidationDate',
      'Cell': ({row}) => {
        return <>{((row.original.liquidationDate) || '')?.substring(0, 10)}</>;
      },
    },
    {
      'Header': 'PRECIO',
      'accessor': 'price',
    },
    {
      'Header': 'ACCESORIOS',
      'accessor': 'combo',
    },
    {
      'Header': 'HUNTER',
      'accessor': 'hunter',
      'Cell': ({row}) => {
        return (<div style={{'textAlign': 'center'}}>{row.original.hunter}</div>);
      },
    },
  ];
};
